
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[author]",
      function () {
        return require("private-next-pages/[author]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[author]"])
      });
    }
  